import React from "react";
import Navbar from "../Components/Navbar";
import StaffPage1 from "../Components/StaffPage1";
import StaffPage2 from "../Components/StaffPage2";
import Footer from "../Components/Footer";
import '../Styles/AboutStaff.scss';
import {Helmet} from "react-helmet";

function AboutStaff() {
   return (
      <div>
         <Helmet>
            <title>Staff - Camp Connect</title>
         </Helmet>
         <div className="staffNavbar">
            <Navbar />
         </div>
         <StaffPage1/>
         <StaffPage2/>
         <Footer/>
      </div>
   )
};

export default AboutStaff;
